<template>
  <div class="right-panel" v-if="isValidProgram">
    <div class="row mb-3">
      <div class="col col-xs-12 col-sm-8 form-input">
        <a :title="`Back to ${terms?.ProgramPlural.toLowerCase()}`" href="#" @click="backToProgram"><i class="bi bi-arrow-left"></i></a>
        <span @click="backToProgram" class="back">Back</span>
      </div>
      <div class="col col-xs-6 col-sm-6 pt-3">
        <h2>Add Participants to a {{terms?.Program.toLowerCase()}}</h2>
        <h5 v-if="programData">
          {{ `Add to: ${programData.programName}` }}
          <span class="par-count" v-if="programData">
            {{
              `(${programData.registeredParticipants} of ${programData.participantMaxCount})`
            }}</span>
        </h5>
      </div>
      <div class="col col-xs-12 col-sm-6 text-right">
        <button class="btn btn-primary" :disabled="!allowedMoreToAdd" @click="onAddClick">
          <i class="bi bi-person-plus"></i>
          Create a new participant
        </button>
      </div>
      <!-- <div class="col col-xs-12">
        <h5 v-if="programData">{{ `Add to: ${programData.programName}` }}</h5>
      </div> -->
    </div>
    <div class="row mb-3">
      <div class="col col-xs-12 col-sm-3 form-input">
        <label for="basic-url">Search by Name</label>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Enter first or last name"
            aria-label="Enter first or last name" @input="searchByNameDebounce" />
        </div>
      </div>
    </div>
    <div>
      <button class="btn btn-success" @click="onaddParticipantClick"
        :disabled="!allowedMoreToAdd || isMorethanSelected || !hasSelected">
        <i class="bi bi-plus"></i> Add selected participants
      </button>
      <span class="error" v-if="(!allowedMoreToAdd || isMorethanSelected) && programData">Not allowed to add more than
        the {{terms?.Program.toLowerCase()}} maximum participants count
        {{ `(${programData.registeredParticipants} of ${programData.participantMaxCount})` }}</span>
    </div>
    <div class="table-wrapper my-3">
      <EasyDataTable v-model:items-selected="itemsSelected" v-model:server-options="serverOptions"
        table-class-name="datatable" :headers="headers" :items="items" :server-items-length="totalCount"
        :loading="isLoadingProgramParticipants" buttons-pagination @expand-row="" :alternating="true" must-sort
        class="data-table">
        <template #expand="item">
          <div class="pa-4">
            <div class="row pb-4" v-if="programCategoryId == 1">
              <div class="row pb-4">
                <div class="col">
                  <b>Guardian First Name: </b>
                  <span>{{ item.guardianFirstName ?? 'N/A' }}</span>
                </div>
                <div class="col" v-if="programCategoryId == 1">
                  <b>Guardian Surname: </b>
                  <span>{{ item.guardianLastName ?? 'N/A' }}</span>
                </div>
                <div class="col">
                  <b>Club Hand: </b>
                  <span>{{
                    item.playingHand ? (item.playingHand == 'R' ? 'Right' : 'Left') : 'N/A'
                    }}</span>
                </div>
                <div class="col">
                  <b>D.O.B: </b>
                  <span>{{ item.dob ?? 'N/A' }}</span>
                </div>
              </div>
              <div class="row pb-4">
                <div class="col">
                  <b>Disability: </b>
                  <span>{{ item.hasSpecialNeeds == 'True' ? 'Yes' : 'No' }}</span>
                </div>
                <div class="col">
                  <b>Disability Comments: </b>
                  <span>{{ item.specialNeedsComment ?? 'N/A' }}</span>
                </div>
                <div class="col">
                  <b>Medical Info: </b>
                  <span>{{ item.otherComments ?? 'N/A' }}</span>
                </div>
                <div class="col"></div>
              </div>
            </div>
            <div class="row pb-4" v-else>
              <div class="col">
                <b>Club Hand: </b>
                <span>{{
                  item.playingHand ? (item.playingHand == 'R' ? 'Right' : 'Left') : 'N/A'
                  }}</span>
              </div>
              <div class="col">
                <b>D.O.B: </b>
                <span>{{ item.dob ?? 'N/A' }}</span>
              </div>
              <div class="col">
                <b>Disability: </b>
                <span>{{ item.hasSpecialNeeds == 'True' ? 'Yes' : 'No' }}</span>
              </div>
              <div class="col">
                <b>Disability Comments: </b>
                <span>{{ item.specialNeedsComment ?? 'N/A' }}</span>
              </div>
              <div class="col">
                <b>Medical Info: </b>
                <span>{{ item.otherComments ?? 'N/A' }}</span>
              </div>
            </div>
          </div>
        </template>
      </EasyDataTable>
    </div>
    <div>
      <button class="btn btn-success" @click="onaddParticipantClick"
        :disabled="!allowedMoreToAdd || isMorethanSelected || !hasSelected">
        <i class="bi bi-plus"></i> Add selected participants
      </button>
      <span class="error" v-if="(!allowedMoreToAdd || isMorethanSelected) && programData">Not allowed to add more than
        the
        {{terms?.Program.toLowerCase()}} maximum participants count
        {{ `(${programData.registeredParticipants} of ${programData.participantMaxCount})` }}</span>
    </div>
  </div>
  <div v-else>
    <h3>You do not have permissions to access this.</h3>
  </div>
  <Notification ref="notificationMsg" colorScheme="text-bg-success">
    <template #body> Selected participants has been successfully registered! </template>
  </Notification>

  <Modal v-if="programData" width="53%"
    :title="`You are adding ${itemsToAdd.length} participant(s) to ${programData.programName}`" ref="addModal">
    <template #body>
      <div class="row mb-3">
        <div class="col col-xs-12 mb-3">
          <EasyDataTable table-class-name="datatable" :headers="addedParticipantHeaders" :items="itemsToAdd" hide-footer
            :alternating="true" must-sort class="data-table">
             <template #item-operation="item">
                <button @click="deleteItem(item)" class="btn-delete"> <i class="bi bi-trash ms-1"></i></button>
            </template>
            </EasyDataTable>
        </div>
        <div class="col col-xs-6" style="z-index: 9999">
          <a href="#" @click="addModal.hide()"> Add more participants </a>
        </div>
        <div class="col col-xs-6 text-right" style="z-index: 9999">
          <button class="btn btn-success" @click="processAdd"><i class="bi bi-check"></i>Ok</button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import type { Item, ServerOptions } from 'vue3-easy-data-table'
import Notification from '@/components/common/Notification.vue'
import Modal from '@/components/common/Modal.vue'
import { ref, watch, onMounted, computed } from 'vue'
import { useProgramStore } from '@/stores/program-store'
import { debounce } from 'lodash'
import router from '@/router'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useAuthStore } from "@/stores/auth-store";
import { useTermsStore } from "@/stores/language-terms";
const { terms } = storeToRefs(useTermsStore());

const route = useRoute()
const { getLoginOrgInfo } = useAuthStore();
const { registerSelectedParticipants, getAllParticipantsOnAdd } = useProgramStore()
const { getProgramById } = useProgramStore()
const { participants, totalCount, isLoadingProgramParticipants, programData } = storeToRefs(
  useProgramStore()
)
const { orgInfo } = storeToRefs(useAuthStore());


const isValidProgram = ref(true);
const itemsSelected = ref<Item[]>([])
const searchByName = ref()
let notificationMsg = ref<any | null>(null)
let addModal = ref<any | null>(null)

const programUID = computed(() => {
  return route.params.programUID as string;
})

const programCategoryId = computed(() => {
  return programData.value && programData.value.programCategoryId;
})

const isMyGolf = computed(() => {
  return programData.value && programData.value.programCategoryId == 1;
})

const allowedMoreToAdd = computed(() => {
  return (
    programData.value &&
    programData.value.participantMaxCount > programData.value.registeredParticipants
  )
})

const remainingParticipantToAdd = computed(() => {
  return (
    programData.value &&
    programData.value.participantMaxCount - programData.value.registeredParticipants
  )
})

const isMorethanSelected = computed(() => {
  return itemsToAdd.value.length > remainingParticipantToAdd.value
})

const hasSelected = computed(() => {
  return itemsToAdd.value.length > 0
})

const itemsToAdd = computed(() => {
  if(itemsSelected.value.length === 0) return [];
  return itemsSelected.value.filter((obj, index, self) =>
    index === self.findIndex((o) => o.id === obj.id)
  );
})

const searchByNameDebounce = debounce(($event) => {
  if ($event.target.value && $event.target.value.length <= 2) return
  searchByName.value = $event.target.value
}, 600)

const items = ref<Item[]>([])
const headers = ref([
  {
    text: 'First Name',
    value: 'firstName',
    sortable: true
  },
  {
    text: 'Last Name',
    value: 'lastName',
    sortable: true
  },
  {
    text: 'Gender',
    value: 'gender',
    sortable: true
  },
  {
    text: 'Guardian Email',
    value: 'guardianEmail',
    sortable: true
  },
  {
    text: 'Guardian Phone',
    value: 'guardianPhone',
    sortable: true
  }
])

const addedParticipantHeaders = ref([
  {
    text: 'First Name',
    value: 'firstName',
    sortable: true,
    width: 170
  },
  {
    text: 'Last Name',
    value: 'lastName',
    sortable: true,
    width: 170
  },
  {
    text: 'Gender',
    value: 'gender',
    sortable: true
  },
  {
    text: 'Guardian Email',
    value: 'guardianEmail',
    sortable: true,
    width: 150,
  },
  {
    text: 'Guardian Phone',
    value: 'guardianPhone',
    sortable: true,
    width: 170,
  },
  {
    text: '',
    value: 'operation',
    sortable: false
  }
])

const serverOptions = ref<ServerOptions>({
  page: 1,
  rowsPerPage: 20,
  sortBy: 'dateCreated',
  sortType: 'desc'
})

const deleteItem = (item) => {
  const items = itemsToAdd.value.filter((x) => x.id === item.id)
  if (items.length > 0) {
    itemsSelected.value = itemsSelected.value.filter((x) => items.some((y) => y.id != x.id))
    if(itemsSelected.value.length == 0) {
      addModal.value.hide();
    }
  }
}

const loadProgramParticipants = async () => {
  await getAllParticipantsOnAdd(
    searchByName.value,
    serverOptions.value.page,
    serverOptions.value.rowsPerPage,
    serverOptions.value.sortBy,
    serverOptions.value.sortType,
    programUID.value,
    programData && programData.value.programCategoryId
  )
  items.value = participants.value
}

onMounted(async () => {
  await getLoginOrgInfo();
  await getProgramById(programUID.value, orgInfo?.value?.clubId)

  if (!isMyGolf.value) {
    let entryIndex = headers.value.findIndex(x => x.text == 'Guardian Email')
    headers.value.splice(entryIndex, 1)

    entryIndex = headers.value.findIndex(x => x.text == 'Guardian Phone')
    headers.value.splice(entryIndex, 1)

    headers.value.push({
      text: 'Email',
      value: 'email',
      sortable: true
    })

    headers.value.push({
      text: 'Phone',
      value: 'phone',
      sortable: true
    })
  }

  if (programData.value) {
    isValidProgram.value = true;
  } else {
    isValidProgram.value = false
  }
  await loadProgramParticipants()
})

watch([searchByName, serverOptions], async () => {
  await loadProgramParticipants()
})

const backToProgram = async () => {
  await router.push({
    name: 'ParticipationProgramParticipants',
    params: {
      programUID: programUID.value
    },
    query: route.query
  })
}

const onaddParticipantClick = () => {
  addModal.value.show()
}

const processAdd = async () => {
  const result = await registerSelectedParticipants(
    itemsToAdd.value.map((x) => x.detailId),
    programUID.value,
    false
  )
  if (result) {
    addModal.value.hide()
    notificationMsg?.value?.show()
    setTimeout(async () => {
      await router.push({
        name: 'ParticipationProgramParticipants',
        params: {
          programUID: programUID.value
        }
      })
    }, 1000)
  }
}

const onAddClick = async () => {
  await router.push({
    name: 'ParticipantsProgramRegistration',
    params: {
      programUID: programUID.value
    },
    query: route.query
  })
}
</script>

<style scoped>
.mr-1 {
  margin-right: 10px !important;
}

label.form-label {
  font-size: 13px;
}

.delivererModal .form-input label {
  padding-bottom: 5px;
  margin-bottom: 0;
}

.delivererModal .form-input {
  margin-bottom: 10px;
}

.par-count {
  font-size: 16px;
}

.text-right {
  text-align: right;
}

.error {
  display: block;
  width: 100%;
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

.back {
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
}
</style>
